import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
import {
  FaSchool,
  //   FaFilm,
  FaShoppingCart,
  FaUtensils,
  FaHospitalSymbol,
} from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";

const LocationBenefits2 = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <FaSchool />,
      title: "Education",
      details: [
        "St. Anne's High Scl - 1.8 Km",
        "Db Ambani Intl Scl - 7.5 Km ",
        "American Scl of Bombay - 7.2 Km",
        "Apostolic Carmel Hi Scl - 2 Km ",
        "St. Andrew's College - 2 Km",
      ],
    },
    {
      icon: <FaHospitalSymbol />,
      title: "Hospitals",
      details: [
        "Lilavati Hospital - 3.3 Km ",
        "Holy Family Hospital - 2 Km",
        "Bhabha Hospital - 2 Km",
        "Hinduja Healthcare Surgical - 1 Km",
        "P. D. Hinduja Hospital - 5.2 Km",
      ],
    },

    {
      icon: <FaShoppingCart />,
      title: "Malls",
      details: [
        "Elco Arcade Mall - 2.2 Km ",
        "Globus Mall - 2.1 Km",
        "Linking Rd Shopping Street - 1.3 Km",
        "Hill Rd Shopping Street - 2.3 Km",
        "Jio World Drive - 4.5 Km",
      ],
    },
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Western Express Hwy - 5 Km",
        "Bandra-Worli Sea Link - 3.8 Km",
        "Bandra Railway Stn - 4.4 Km",
        "Airport - 5.4 Km",
        "Bandra-Kurla Complex - 6 Km",
      ],
    },
    {
      icon: <FaUtensils />,
      title: "Restaurants",
      details: [
        "Suzette - 1.2 Km ",
        "Boojee Cafe - 600 m ",
        "Eat Around the Corner - 1.3 Km",
        "Candies - 1.4 Km ",
        "The Bagel Shop - 1.4 Km",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                {project} - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" - "); // Using " - " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>
                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " - "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span
                className="new-button "
                onClick={() => handleShowModal("Location Benefits")}
              >
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
